import React, { useState, useEffect } from 'react'
import { Panel, IconButton, Icon, Grid, Row, Col, Input, InputGroup, InputNumber } from 'rsuite'
import CustomIconMessageInfo from '../../../CustomIconMessageInfo'
import { requiredFiled, isValidators } from '../../../../utils/ValidatorUtils'
import ErrorMessage from '../../../../components/message/errorMessage/ErrorMessage'
import CKEditorFrom from '../../../../components/forms/input/CKEditorFrom'
import NumberFormat from 'react-number-format'
import InputForm from '../../../../components/forms/input/InputForm'

export default function GarbageBGForm({
  schema,
  register,
  errors,
  Controller,
  control,
  setValue,
  getValues,
  clearErrors,
}) {
  // const [communityBasicInfo, setCommunityBasicInfo] = useState()

  const communityBasicInfo = schema.communityBasicInfo && schema.communityBasicInfo
  const situationOfWaste = schema.situationOfWaste && schema.situationOfWaste

  const [garbageSortMethod, setGarbageSortMethod] = useState([])
  const [garbageBenefitMethod, setGarbageBenefitMethod] = useState([])

  const [allHouseholdsPercentage, setAllHouseholdsPercentage] = useState(
    situationOfWaste.garbageManagement.allHouseholdsPercentage.value
  )
  const [garbageSortBeforPercentage, setGarbageSortBeforPercentage] = useState(
    situationOfWaste.garbageManagement.garbageSortBeforPercentage.value
  )
  const [garbageBenefitPercentage, setGarbageBenefitPercentage] = useState(
    situationOfWaste.garbageManagement.garbageBenefitPercentage.value
  )
  const [garbageNoSortPercentage, setGarbageNoSortPercentage] = useState(
    situationOfWaste.garbageManagement.garbageNoSortPercentage.value
  )

  useEffect(() => {
    if (situationOfWaste) {
      let garbageSortMethod = [
        ...situationOfWaste.garbageManagement.garbageSortBenefit.garbageSortMethod.value,
      ]

      let garbageBenefitMethod = [
        ...situationOfWaste.garbageManagement.garbageSortBenefit.garbageBenefitMethod.value,
      ]

      setGarbageSortMethod(garbageSortMethod)
      setGarbageBenefitMethod(garbageBenefitMethod)
      setValue(
        situationOfWaste.garbageManagement.garbageSortBenefit.garbageSortMethod.name,
        garbageSortMethod
      )
      setValue(
        situationOfWaste.garbageManagement.garbageSortBenefit.garbageBenefitMethod.name,
        garbageBenefitMethod
      )
    }
  }, [schema])

  const createIputNumber = (obj, labelFalse) => {
    return (
      <Row>
        <Col xs={24} sm={24} md={24} lg={24}>
          <ErrorMessage error={errors[obj.name]} />
          {labelFalse === true && (
            <p style={{ marginLeft: 20 }}>{requiredFiled(obj.validators, obj.label)}</p>
          )}
          <InputGroup style={{ marginLeft: 20, marginBottom: 10, marginRight: 20, width: '95%' }}>
            {obj.preLabel && <InputGroup.Addon>{obj.preLabel}</InputGroup.Addon>}
            <Controller
              key={obj.name}
              name={obj.name}
              control={control}
              rules={isValidators(obj.validators)}
              defaultValue={obj.value}
              render={(props) => {
                return (
                  <NumberFormat
                    className="rs-input"
                    thousandSeparator={true}
                    defaultValue={props.value}
                    placeholder={obj.hint || obj.label}
                    onValueChange={(value) => {
                      props.onChange(value.floatValue)
                    }}
                  />
                )
              }}
            />
            {obj.postLabel && <InputGroup.Addon>{obj.postLabel}</InputGroup.Addon>}
          </InputGroup>
        </Col>
      </Row>
    )
  }

  return (
    <>
      <Panel header="">
        <Grid fluid>
          <Row>
            {communityBasicInfo && (
              <Col xs={24} sm={24} md={24} lg={24}>
                <InputForm
                  schema={communityBasicInfo}
                  rows={3}
                  componentClass="textarea"
                  register={register}
                  Controller={Controller}
                  control={control}
                  errors={errors}
                  setValue={setValue}
                  clearErrors={clearErrors}
                />
                {/* <ErrorMessage error={errors[communityBasicInfo.name]} />
                <p style={{ marginBottom: 10, marginTop: 10 }}>
                  <b>{requiredFiled(communityBasicInfo.validators, communityBasicInfo.label)}</b>
                </p>
                {communityBasicInfo.description && (
                  <CustomIconMessageInfo
                    style={{ marginBottom: 10 }}
                    contents={communityBasicInfo.description}
                  />
                )}

                <Input
                  componentClass="textarea"
                  rows={3}
                  style={{ width: '100%', marginTop: 10 }}
                  name={communityBasicInfo.name}
                  defaultValue={communityBasicInfo.value}
                  inputRef={register(isValidators(communityBasicInfo.validators))}
                /> */}
              </Col>
            )}
          </Row>

          {situationOfWaste && (
            <Row>
              <Col xs={24} sm={24} md={24} lg={24}>
                <p style={{ marginTop: 10, marginBottom: 10 }}>
                  {requiredFiled(situationOfWaste.validators, situationOfWaste.label)}
                </p>
                {situationOfWaste.description && (
                  <CustomIconMessageInfo
                    style={{ marginBottom: 10 }}
                    contents={situationOfWaste.description}
                  />
                )}
              </Col>

              <br />
              <Col xs={24} sm={24} md={24} lg={8}>
                <ErrorMessage error={errors[situationOfWaste.community.name]} />
                <p style={{ marginLeft: 20 }}>
                  {requiredFiled(
                    situationOfWaste.community.validators,
                    situationOfWaste.community.label
                  )}
                </p>
                <Input
                  style={{ marginLeft: 20, marginBottom: 10, marginRight: 20, width: '95%' }}
                  placeholder={situationOfWaste.community.hint || situationOfWaste.community.label}
                  name={situationOfWaste.community.name}
                  defaultValue={situationOfWaste.community.value}
                  inputRef={register(isValidators(situationOfWaste.community.validators))}
                />
              </Col>
              <Col xs={24} sm={12} md={24} lg={8}>
                {createIputNumber(situationOfWaste.household, true)}
              </Col>
              <Col xs={24} sm={12} md={24} lg={7}>
                {createIputNumber(situationOfWaste.population, true)}
              </Col>
              <br />
              <Col xs={24} sm={24} md={24} lg={12}>
                {createIputNumber(situationOfWaste.garbageAverage, true)}
              </Col>
              <Col xs={24} sm={24} md={24} lg={12}>
                <ErrorMessage error={errors[situationOfWaste.garbageType.name]} />
                <p style={{ marginLeft: 20 }}>
                  {requiredFiled(
                    situationOfWaste.garbageType.validators,
                    situationOfWaste.garbageType.label
                  )}
                </p>
                <Input
                  style={{ marginLeft: 20, marginBottom: 10, marginRight: 20, width: '95%' }}
                  placeholder={
                    situationOfWaste.garbageType.hint || situationOfWaste.garbageType.label
                  }
                  name={situationOfWaste.garbageType.name}
                  defaultValue={situationOfWaste.garbageType.value}
                  inputRef={register(isValidators(situationOfWaste.garbageType.validators))}
                />
              </Col>
              <br />
              <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 10, paddingLeft: 20 }}>
                <InputForm
                  schema={situationOfWaste.problemState}
                  rows={3}
                  componentClass="textarea"
                  register={register}
                  Controller={Controller}
                  control={control}
                  errors={errors}
                  setValue={setValue}
                  clearErrors={clearErrors}
                />
                {/* <ErrorMessage error={errors[situationOfWaste.problemState.name]} />
                  <p style={{ marginLeft: 20 }}>
                    {requiredFiled(
                      situationOfWaste.problemState.validators,
                      situationOfWaste.problemState.label
                    )}
                  </p>
                  <Input
                    componentClass="textarea"
                    rows={3}
                    style={{ marginLeft: 20, width: '98%' }}
                    placeholder={situationOfWaste.problemState.hint}
                    name={situationOfWaste.problemState.name}
                    defaultValue={situationOfWaste.problemState.value}
                    inputRef={register(isValidators(situationOfWaste.problemState.validators))}
                  /> */}
              </Col>

              <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 10, paddingLeft: 20 }}>
                <InputForm
                  schema={situationOfWaste.problemCase}
                  rows={3}
                  componentClass="textarea"
                  register={register}
                  Controller={Controller}
                  control={control}
                  errors={errors}
                  setValue={setValue}
                  clearErrors={clearErrors}
                />
                {/* <ErrorMessage error={errors[situationOfWaste.problemCase.name]} />
                  <p style={{ marginLeft: 20 }}>
                    {requiredFiled(
                      situationOfWaste.problemCase.validators,
                      situationOfWaste.problemCase.label
                    )}
                  </p>
                  <Input
                    componentClass="textarea"
                    rows={3}
                    style={{ marginLeft: 20, width: '98%' }}
                    placeholder={situationOfWaste.problemCase.hint}
                    name={situationOfWaste.problemCase.name}
                    defaultValue={situationOfWaste.problemCase.value}
                    inputRef={register(isValidators(situationOfWaste.problemCase.validators))}
                  /> */}
              </Col>

              <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 10, paddingLeft: 20 }}>
                <InputForm
                  schema={situationOfWaste.impactCommunity}
                  rows={3}
                  componentClass="textarea"
                  register={register}
                  Controller={Controller}
                  control={control}
                  errors={errors}
                  setValue={setValue}
                  clearErrors={clearErrors}
                />
                {/* <ErrorMessage error={errors[situationOfWaste.impactCommunity.name]} />
                  <p style={{ marginLeft: 20 }}>
                    {requiredFiled(
                      situationOfWaste.impactCommunity.validators,
                      situationOfWaste.impactCommunity.label
                    )}
                  </p>
                  <Input
                    componentClass="textarea"
                    rows={3}
                    style={{ marginLeft: 20, width: '98%' }}
                    placeholder={situationOfWaste.impactCommunity.hint}
                    name={situationOfWaste.impactCommunity.name}
                    defaultValue={situationOfWaste.impactCommunity.value}
                    inputRef={register(isValidators(situationOfWaste.impactCommunity.validators))}
                  /> */}
              </Col>
            </Row>
          )}

          <Row>
            <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 10 }}>
              <p style={{ marginLeft: 20, marginBottom: 5 }}>
                {requiredFiled(
                  situationOfWaste.garbageManagement.validators,
                  situationOfWaste.garbageManagement.label
                )}
              </p>
              <Panel>
                <Row style={{ marginBottom: 10 }}>
                  <Col xs={24} sm={24} md={24} lg={6} style={{ marginLeft: 20, marginBottom: 10 }}>
                    {requiredFiled(
                      situationOfWaste.garbageManagement.allHouseholds.validators,
                      situationOfWaste.garbageManagement.allHouseholds.label
                    )}
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={8} style={{ marginBottom: 10 }}>
                    {/* {createIputNumber(situationOfWaste.garbageManagement.allHouseholds)} */}

                    <ErrorMessage
                      error={errors[situationOfWaste.garbageManagement.allHouseholds.name]}
                    />
                    <InputGroup
                      style={{ marginLeft: 20, marginBottom: 10, marginRight: 20, width: '95%' }}
                    >
                      <InputGroup.Addon>
                        {situationOfWaste.garbageManagement.allHouseholds.preLabel}
                      </InputGroup.Addon>
                      <Controller
                        key={situationOfWaste.garbageManagement.allHouseholds.name}
                        name={situationOfWaste.garbageManagement.allHouseholds.name}
                        control={control}
                        rules={isValidators(
                          situationOfWaste.garbageManagement.allHouseholds.validators
                        )}
                        defaultValue={situationOfWaste.garbageManagement.allHouseholds.value}
                        render={(props) => {
                          return (
                            // <InputNumber
                            <NumberFormat
                              className="rs-input"
                              thousandSeparator={true}
                              value={props.value}
                              placeholder={
                                situationOfWaste.garbageManagement.allHouseholds.hint ||
                                situationOfWaste.garbageManagement.allHouseholds.label
                              }
                              onValueChange={(e) => {
                                let value = e.floatValue
                                props.onChange(value)

                                if (value > 0) {
                                  setAllHouseholdsPercentage(100)

                                  let garbageSortBefor = getValues(
                                    situationOfWaste.garbageManagement.garbageSortBefor.name
                                  )
                                  setGarbageSortBeforPercentage(
                                    garbageSortBefor || garbageSortBefor > 0
                                      ? ((garbageSortBefor * 100) / value).toFixed(2)
                                      : 0
                                  )

                                  let garbageBenefit = getValues(
                                    situationOfWaste.garbageManagement.garbageBenefit.name
                                  )
                                  setGarbageBenefitPercentage(
                                    garbageBenefit || garbageBenefit > 0
                                      ? ((garbageBenefit * 100) / value).toFixed(2)
                                      : 0
                                  )

                                  let garbageNoSort = getValues(
                                    situationOfWaste.garbageManagement.garbageNoSort.name
                                  )
                                  setGarbageNoSortPercentage(
                                    garbageNoSort || garbageNoSort > 0
                                      ? ((garbageNoSort * 100) / value).toFixed(2)
                                      : 0
                                  )
                                } else {
                                  setAllHouseholdsPercentage('')
                                  setGarbageSortBeforPercentage('')
                                  setGarbageBenefitPercentage('')
                                  setGarbageNoSortPercentage('')
                                }
                              }}
                            />
                          )
                        }}
                      />
                      <InputGroup.Addon>
                        {situationOfWaste.garbageManagement.allHouseholds.postLabel}
                      </InputGroup.Addon>
                    </InputGroup>
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={5} style={{ marginBottom: 10 }}>
                    <InputGroup>
                      <InputGroup.Addon>
                        {requiredFiled(
                          situationOfWaste.garbageManagement.allHouseholdsPercentage.validators,
                          situationOfWaste.garbageManagement.allHouseholdsPercentage.preLabel
                        )}
                      </InputGroup.Addon>
                      <Input
                        disabled
                        placeholder={
                          situationOfWaste.garbageManagement.allHouseholdsPercentage.hint
                        }
                        value={allHouseholdsPercentage}
                      />
                    </InputGroup>
                  </Col>
                </Row>
                <Row style={{ marginBottom: 10 }}>
                  <Col xs={24} sm={24} md={24} lg={6} style={{ marginLeft: 20, marginBottom: 10 }}>
                    {requiredFiled(
                      situationOfWaste.garbageManagement.garbageSortBefor.validators,
                      situationOfWaste.garbageManagement.garbageSortBefor.label
                    )}
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={8} style={{ marginBottom: 10 }}>
                    {/* {createIputNumber(situationOfWaste.garbageManagement.garbageSortBefor)} */}
                    <ErrorMessage
                      error={errors[situationOfWaste.garbageManagement.garbageSortBefor.name]}
                    />
                    <InputGroup
                      style={{ marginLeft: 20, marginBottom: 10, marginRight: 20, width: '95%' }}
                    >
                      <InputGroup.Addon>
                        {situationOfWaste.garbageManagement.garbageSortBefor.preLabel}
                      </InputGroup.Addon>
                      <Controller
                        key={situationOfWaste.garbageManagement.garbageSortBefor.name}
                        name={situationOfWaste.garbageManagement.garbageSortBefor.name}
                        control={control}
                        rules={isValidators(
                          situationOfWaste.garbageManagement.garbageSortBefor.validators
                        )}
                        defaultValue={situationOfWaste.garbageManagement.garbageSortBefor.value}
                        render={(props) => {
                          return (
                            // <InputNumber
                            <NumberFormat
                              className="rs-input"
                              thousandSeparator={true}
                              value={props.value}
                              placeholder={
                                situationOfWaste.garbageManagement.garbageSortBefor.hint ||
                                situationOfWaste.garbageManagement.garbageSortBefor.label
                              }
                              onValueChange={(e) => {
                                let value = e.floatValue
                                props.onChange(value)

                                let allHouseholds = getValues(
                                  situationOfWaste.garbageManagement.allHouseholds.name
                                )
                                setGarbageSortBeforPercentage(
                                  allHouseholds || allHouseholds > 0
                                    ? ((value * 100) / allHouseholds).toFixed(2)
                                    : 0
                                )
                              }}
                            />
                          )
                        }}
                      />
                      <InputGroup.Addon>
                        {situationOfWaste.garbageManagement.allHouseholds.postLabel}
                      </InputGroup.Addon>
                    </InputGroup>
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={5} style={{ marginBottom: 10 }}>
                    <InputGroup>
                      <InputGroup.Addon>
                        {requiredFiled(
                          situationOfWaste.garbageManagement.garbageSortBeforPercentage.validators,
                          situationOfWaste.garbageManagement.garbageSortBeforPercentage.preLabel
                        )}
                      </InputGroup.Addon>
                      <Input
                        disabled
                        placeholder={
                          situationOfWaste.garbageManagement.garbageSortBeforPercentage.hint
                        }
                        value={garbageSortBeforPercentage}
                      />
                    </InputGroup>
                  </Col>
                </Row>
                <Row style={{ marginBottom: 10 }}>
                  <Col xs={24} sm={24} md={24} lg={6} style={{ marginLeft: 20, marginBottom: 10 }}>
                    {requiredFiled(
                      situationOfWaste.garbageManagement.garbageBenefit.validators,
                      situationOfWaste.garbageManagement.garbageBenefit.label
                    )}
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={8} style={{ marginBottom: 10 }}>
                    {/* {createIputNumber(situationOfWaste.garbageManagement.garbageBenefit)} */}
                    <ErrorMessage
                      error={errors[situationOfWaste.garbageManagement.garbageBenefit.name]}
                    />
                    <InputGroup
                      style={{ marginLeft: 20, marginBottom: 10, marginRight: 20, width: '95%' }}
                    >
                      <InputGroup.Addon>
                        {situationOfWaste.garbageManagement.garbageBenefit.preLabel}
                      </InputGroup.Addon>
                      <Controller
                        key={situationOfWaste.garbageManagement.garbageBenefit.name}
                        name={situationOfWaste.garbageManagement.garbageBenefit.name}
                        control={control}
                        rules={isValidators(
                          situationOfWaste.garbageManagement.garbageBenefit.validators
                        )}
                        defaultValue={situationOfWaste.garbageManagement.garbageBenefit.value}
                        render={(props) => {
                          return (
                            // <InputNumber
                            <NumberFormat
                              className="rs-input"
                              thousandSeparator={true}
                              value={props.value}
                              placeholder={
                                situationOfWaste.garbageManagement.garbageBenefit.hint ||
                                situationOfWaste.garbageManagement.garbageBenefit.label
                              }
                              onValueChange={(e) => {
                                let value = e.floatValue
                                props.onChange(value)

                                let allHouseholds = getValues(
                                  situationOfWaste.garbageManagement.allHouseholds.name
                                )
                                setGarbageBenefitPercentage(
                                  allHouseholds || allHouseholds > 0
                                    ? ((value * 100) / allHouseholds).toFixed(2)
                                    : 0
                                )
                              }}
                            />
                          )
                        }}
                      />
                      <InputGroup.Addon>
                        {situationOfWaste.garbageManagement.garbageBenefit.postLabel}
                      </InputGroup.Addon>
                    </InputGroup>
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={5} style={{ marginBottom: 10 }}>
                    <InputGroup>
                      <InputGroup.Addon>
                        {situationOfWaste.garbageManagement.garbageBenefitPercentage.preLabel}
                      </InputGroup.Addon>
                      <Input
                        disabled
                        placeholder={
                          situationOfWaste.garbageManagement.garbageBenefitPercentage.hint
                        }
                        value={garbageBenefitPercentage}
                      />
                    </InputGroup>
                  </Col>
                </Row>
                <Row style={{ marginBottom: 10 }}>
                  <Col xs={24} sm={24} md={24} lg={6} style={{ marginLeft: 20, marginBottom: 10 }}>
                    {requiredFiled(
                      situationOfWaste.garbageManagement.garbageNoSort.validators,
                      situationOfWaste.garbageManagement.garbageNoSort.label
                    )}
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={8} style={{ marginBottom: 10 }}>
                    {/* {createIputNumber(situationOfWaste.garbageManagement.garbageNoSort)} */}
                    <ErrorMessage
                      error={errors[situationOfWaste.garbageManagement.garbageNoSort.name]}
                    />
                    <InputGroup
                      style={{ marginLeft: 20, marginBottom: 10, marginRight: 20, width: '95%' }}
                    >
                      <InputGroup.Addon>
                        {situationOfWaste.garbageManagement.garbageNoSort.preLabel}
                      </InputGroup.Addon>
                      <Controller
                        key={situationOfWaste.garbageManagement.garbageNoSort.name}
                        name={situationOfWaste.garbageManagement.garbageNoSort.name}
                        control={control}
                        rules={isValidators(
                          situationOfWaste.garbageManagement.garbageNoSort.validators
                        )}
                        defaultValue={situationOfWaste.garbageManagement.garbageNoSort.value}
                        render={(props) => {
                          return (
                            <NumberFormat
                              className="rs-input"
                              thousandSeparator={true}
                              value={props.value}
                              placeholder={
                                situationOfWaste.garbageManagement.garbageNoSort.hint ||
                                situationOfWaste.garbageManagement.garbageNoSort.label
                              }
                              onValueChange={(e) => {
                                let value = e.floatValue
                                props.onChange(value)

                                let allHouseholds = getValues(
                                  situationOfWaste.garbageManagement.allHouseholds.name
                                )
                                setGarbageNoSortPercentage(
                                  allHouseholds || allHouseholds > 0
                                    ? ((value * 100) / allHouseholds).toFixed(2)
                                    : 0
                                )
                              }}
                            />
                          )
                        }}
                      />
                      <InputGroup.Addon>
                        {situationOfWaste.garbageManagement.garbageNoSort.postLabel}
                      </InputGroup.Addon>
                    </InputGroup>
                  </Col>
                  <Col xs={24} sm={24} md={24} lg={5} style={{ marginBottom: 10 }}>
                    <InputGroup>
                      <InputGroup.Addon>
                        {requiredFiled(
                          situationOfWaste.garbageManagement.garbageNoSortPercentage.validators,
                          situationOfWaste.garbageManagement.garbageNoSortPercentage.preLabel
                        )}
                      </InputGroup.Addon>
                      <Input
                        disabled
                        placeholder={
                          situationOfWaste.garbageManagement.garbageNoSortPercentage.hint
                        }
                        value={garbageNoSortPercentage}
                      />
                    </InputGroup>
                  </Col>
                </Row>

                <Col style={{ paddingLeft: 20 }}>
                  <ErrorMessage
                    error={errors[situationOfWaste.garbageManagement.garbageSortBenefit.name]}
                  />
                  <p style={{ marginLeft: 0, marginTop: 10 }}>
                    {requiredFiled(
                      situationOfWaste.garbageManagement.garbageSortBenefit.isValidators,
                      situationOfWaste.garbageManagement.garbageSortBenefit.label
                    )}
                  </p>
                </Col>

                <Col style={{ paddingLeft: 20 }}>
                  <Row>
                    <Col style={{ paddingLeft: 20 }}>
                      <ErrorMessage
                        error={
                          errors[
                            situationOfWaste.garbageManagement.garbageSortBenefit.garbageSortMethod
                              .name
                          ]
                        }
                      />
                      <p style={{ marginLeft: 25, marginBottom: 10 }}>
                        {requiredFiled(
                          situationOfWaste.garbageManagement.garbageSortBenefit.garbageSortMethod
                            .isValidators,
                          situationOfWaste.garbageManagement.garbageSortBenefit.garbageSortMethod
                            .label
                        )}
                      </p>
                    </Col>
                    <Controller
                      key={
                        situationOfWaste.garbageManagement.garbageSortBenefit.garbageSortMethod.name
                      }
                      name={
                        situationOfWaste.garbageManagement.garbageSortBenefit.garbageSortMethod.name
                      }
                      control={control}
                      rules={isValidators(
                        situationOfWaste.garbageManagement.garbageSortBenefit.garbageSortMethod
                          .isValidators
                      )}
                      defaultValue={garbageSortMethod}
                    ></Controller>

                    {garbageSortMethod.map((item, index) => {
                      return (
                        <Row style={{ marginBottom: 10, marginLeft: 40 }}>
                          <Col
                            xs={24}
                            sm={1}
                            md={1}
                            lg={1}
                            style={{ textAlign: 'right', marginTop: 5 }}
                          >
                            <p>{index + 1}) </p>
                          </Col>
                          <Col xs={24} sm={20} md={20} lg={20}>
                            <Input
                              value={item}
                              placeholder={
                                situationOfWaste.garbageManagement.garbageSortBenefit
                                  .garbageSortMethod.hint ||
                                situationOfWaste.garbageManagement.garbageSortBenefit
                                  .garbageSortMethod.label
                              }
                              onChange={(value) => {
                                let dataList = [...garbageSortMethod]
                                dataList[index] = value
                                setGarbageSortMethod(dataList)
                                setValue(
                                  situationOfWaste.garbageManagement.garbageSortBenefit
                                    .garbageSortMethod.name,
                                  dataList
                                )
                              }}
                            />
                          </Col>
                          <Col xs={24} sm={24} md={3} lg={3}>
                            <IconButton
                              appearance="ghost"
                              className="rs-btn-ghost-cancel"
                              icon={
                                <Icon
                                  appearance="ghost"
                                  icon="trash-o"
                                  className="bt-gost-icon-radius-cancel"
                                />
                              }
                              onClick={() => {
                                let dataList = [...garbageSortMethod]
                                dataList.splice(index, 1)
                                setGarbageSortMethod(dataList)
                                setValue(
                                  situationOfWaste.garbageManagement.garbageSortBenefit
                                    .garbageSortMethod.name,
                                  dataList
                                )
                              }}
                            >
                              ลบ
                            </IconButton>
                          </Col>
                        </Row>
                      )
                    })}
                    <Col style={{ marginLeft: 62, marginBottom: 10 }}>
                      <IconButton
                        appearance="ghost"
                        icon={
                          <Icon appearance="ghost" icon="plus" className="bt-gost-icon-radius" />
                        }
                        onClick={() => {
                          let dataList = [...garbageSortMethod]
                          dataList.push('')
                          setGarbageSortMethod(dataList)
                        }}
                      >
                        เพิ่ม
                      </IconButton>
                    </Col>
                  </Row>
                </Col>

                <Col style={{ paddingLeft: 20 }}>
                  <Row>
                    <Col style={{ paddingLeft: 20 }}>
                      <ErrorMessage
                        error={
                          errors[
                            situationOfWaste.garbageManagement.garbageSortBenefit
                              .garbageBenefitMethod.name
                          ]
                        }
                      />
                      <p style={{ marginLeft: 25, marginBottom: 10 }}>
                        {requiredFiled(
                          situationOfWaste.garbageManagement.garbageSortBenefit.garbageBenefitMethod
                            .isValidators,
                          situationOfWaste.garbageManagement.garbageSortBenefit.garbageBenefitMethod
                            .label
                        )}
                      </p>
                    </Col>
                    <Controller
                      key={
                        situationOfWaste.garbageManagement.garbageSortBenefit.garbageBenefitMethod
                          .name
                      }
                      name={
                        situationOfWaste.garbageManagement.garbageSortBenefit.garbageBenefitMethod
                          .name
                      }
                      control={control}
                      rules={isValidators(
                        situationOfWaste.garbageManagement.garbageSortBenefit.garbageBenefitMethod
                          .isValidators
                      )}
                      defaultValue={garbageBenefitMethod}
                    ></Controller>
                    {garbageBenefitMethod.map((item, index) => {
                      return (
                        <Row style={{ marginBottom: 10, marginLeft: 40 }}>
                          <Col
                            xs={24}
                            sm={1}
                            md={1}
                            lg={1}
                            style={{ textAlign: 'right', marginTop: 5 }}
                          >
                            <p>{index + 1}) </p>
                          </Col>
                          <Col xs={24} sm={20} md={20} lg={20}>
                            <Input
                              value={item}
                              placeholder={
                                situationOfWaste.garbageManagement.garbageSortBenefit
                                  .garbageBenefitMethod.hint ||
                                situationOfWaste.garbageManagement.garbageSortBenefit
                                  .garbageBenefitMethod.label
                              }
                              onChange={(value) => {
                                let dataList = [...garbageBenefitMethod]
                                dataList[index] = value
                                setGarbageBenefitMethod(dataList)
                                setValue(
                                  situationOfWaste.garbageManagement.garbageSortBenefit
                                    .garbageBenefitMethod.name,
                                  dataList
                                )
                              }}
                            />
                          </Col>
                          <Col xs={24} sm={24} md={3} lg={3}>
                            <IconButton
                              appearance="ghost"
                              className="rs-btn-ghost-cancel"
                              icon={
                                <Icon
                                  appearance="ghost"
                                  icon="trash-o"
                                  className="bt-gost-icon-radius-cancel"
                                />
                              }
                              onClick={() => {
                                let dataList = [...garbageBenefitMethod]
                                dataList.splice(index, 1)
                                setGarbageBenefitMethod(dataList)
                                setValue(
                                  situationOfWaste.garbageManagement.garbageSortBenefit
                                    .garbageBenefitMethod.name,
                                  dataList
                                )
                              }}
                            >
                              ลบ
                            </IconButton>
                          </Col>
                        </Row>
                      )
                    })}
                    <Col style={{ marginLeft: 62, marginBottom: 10 }}>
                      <IconButton
                        appearance="ghost"
                        icon={
                          <Icon appearance="ghost" icon="plus" className="bt-gost-icon-radius" />
                        }
                        onClick={() => {
                          let dataList = [...garbageBenefitMethod]
                          dataList.push('')
                          setGarbageBenefitMethod(dataList)
                        }}
                      >
                        เพิ่ม
                      </IconButton>
                    </Col>
                  </Row>
                </Col>

                <Col xs={24} sm={24} md={24} lg={24} style={{ paddingLeft: 20 }}>
                  <InputForm
                    schema={situationOfWaste.garbageManagement.noSortGarbageManagement}
                    rows={3}
                    componentClass="textarea"
                    register={register}
                    Controller={Controller}
                    control={control}
                    errors={errors}
                    setValue={setValue}
                    clearErrors={clearErrors}
                  />
                </Col>

                {/* <Col xs={24} sm={24} md={24} lg={24} style={{ marginLeft: 20 }}>
                  <ErrorMessage
                    error={errors[situationOfWaste.garbageManagement.noSortGarbageManagement.name]}
                  />
                  <p style={{ marginLeft: 0, marginTop: 10 }}>
                    <b>
                      {requiredFiled(
                        situationOfWaste.garbageManagement.noSortGarbageManagement.validators,
                        situationOfWaste.garbageManagement.noSortGarbageManagement.label
                      )}
                    </b>
                  </p>
                </Col>
                <Col xs={24} sm={24} md={23} lg={23} style={{ marginLeft: 40, marginBottom: 20 }}>
                  <Input
                    componentClass="textarea"
                    rows={3}
                    style={{ marginTop: 10, marginLeft: 8, width: '91%' }}
                    placeholder={situationOfWaste.garbageManagement.noSortGarbageManagement.hint}
                    name={situationOfWaste.garbageManagement.noSortGarbageManagement.name}
                    defaultValue={situationOfWaste.garbageManagement.noSortGarbageManagement.value}
                    inputRef={register(
                      isValidators(
                        situationOfWaste.garbageManagement.noSortGarbageManagement.validators
                      )
                    )}
                  />
                </Col> */}
              </Panel>
            </Col>

            <Row>
              <Col xs={24} sm={24} md={24} lg={24} style={{ marginLeft: 20 }}>
                <InputForm
                  schema={schema.previousGarbageManagement}
                  rows={3}
                  componentClass="textarea"
                  register={register}
                  Controller={Controller}
                  control={control}
                  errors={errors}
                  setValue={setValue}
                  clearErrors={clearErrors}
                />
                {/* <ErrorMessage error={errors[schema.previousGarbageManagement.name]} />
                <p style={{ marginLeft: 0, marginTop: 10 }}>
                  <b>
                    {requiredFiled(
                      schema.previousGarbageManagement.validators,
                      schema.previousGarbageManagement.label
                    )}
                  </b>
                </p>
              </Col>
              <Col xs={24} sm={24} md={23} lg={23} style={{ marginLeft: 40, marginBottom: 20 }}>
                <Input
                  componentClass="textarea"
                  rows={3}
                  style={{ marginTop: 10, marginLeft: 8, width: '91%' }}
                  placeholder={schema.previousGarbageManagement.hint}
                  name={schema.previousGarbageManagement.name}
                  defaultValue={schema.previousGarbageManagement.value}
                  inputRef={register(isValidators(schema.previousGarbageManagement.validators))}
                />*/}
              </Col>
            </Row>
            {/* <Col xs={24} sm={24} md={24} lg={24}>
              <CKEditorFrom
                schema={schema.previousGarbageManagement}
                register={register}
                Controller={Controller}
                control={control}
                errors={errors}
                setValue={setValue}
                clearErrors={clearErrors}
              />
            </Col> */}
          </Row>
        </Grid>
      </Panel>
    </>
  )
}
